import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";
import { InputObject } from "../controls/default";
import { createSearchRequest } from "../hooks/useSearchRequest";
import { getAssetTypes } from "../repository/data.repository";

export interface CompanyAssetsViewForm {
  readonly name: string;
  readonly code: string;
  readonly assetType?: InputObject;
}

export const companyAssetsViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Code",
    key: "code",
    width: 130,
    sort: true,
  },
  {
    title: "Type",
    key: "assetTypeName",
    width: 150,
    sort: true,
  },
  {
    title: "Subtype",
    key: "assetSubtypeName",
    width: 150,
    sort: true,
  },
  {
    title: "Crew",
    key: "usersCount",
    width: 90,
    sort: true,
  },
];

const companyAssetsQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "code" },
  {
    formField: "assetType",
    queryField: "assetTypeUid",
    operation: QueryOperation.Equal,
    transform: comboboxValue,
  },
];

export const mapCompanyAssetsViewQuery = (
  values: CompanyAssetsViewForm,
): SearchQuery => buildSearchQuery(values, companyAssetsQueryMappings);

export const companyAssetsSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "code", label: "Code" },
        {
          type: "combobox",
          name: "assetType",
          label: "Asset Type",
          request: createSearchRequest(getAssetTypes, "name"),
        },
      ],
    },
  ],
};
